var map = {
	"./star0.png": 3838,
	"./star1.png": 5799,
	"./star2.png": 5740,
	"./star3.png": 4837,
	"./star4.png": 4682,
	"./star5.png": 5907,
	"./star6.png": 632,
	"./star7.png": 4849,
	"./star8.png": 6566
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8495;